export default "__VITE_ASSET__8927c464__"